import { getOidcUser } from "app/config/oidc";
import { BFF_ENABLED } from "app/config/bff";

/**
 * API 요청 헤더.
 *
 * ── BFF 를 켜면 Authorization 을 붙이지 않는다
 *
 * 토큰이 화면에 없기 때문이다. 대신 브라우저가 세션 쿠키를 자동으로 보내고, 게이트웨이가
 * 그 세션에서 토큰을 꺼내 하위 서비스로 실어 보낸다.
 *
 * ★ 붙이면 안 되는 것이지 비워도 되는 것이 아니다. 게이트웨이는 Authorization 헤더가
 *   있으면 그것을 그대로 쓰므로(전환 기간에 기존 클라이언트를 받기 위해), 빈 값이나
 *   "undefined undefined" 를 보내면 세션이 있는데도 인증에 실패한다.
 *
 * ── 끄면 지금까지와 같다
 *
 * 저장된 토큰을 읽어 Bearer 로 붙인다. 로그인 전에는 "undefined undefined" 가 나가는데,
 * 그 상태로 부르는 경로(가입·중복확인 등)는 게이트웨이 허용 목록에 있어 통과한다.
 */

/**
 * 반환 타입을 명시한다.
 *
 * 명시하지 않으면 두 분기가 유니온 타입이 되어({@code Authorization?: undefined} 를
 * 포함한다), {@code Dictionary<string>} 를 기대하는 호출부가 컴파일에서 깨진다.
 * 헤더 묶음은 언제나 문자열 맵이다.
 */
const authorizationHeader = (): Record<string, string> => {
  if (BFF_ENABLED) {
    return {};
  }
  const currentUserInfo = getOidcUser();
  return {
    Authorization: `${currentUserInfo?.token_type} ${currentUserInfo?.access_token}`,
  };
};

const getHeaders = (): Record<string, string> => ({
  "Content-Type": "application/json",
  ...authorizationHeader(),
});

const getHeadersAuth = (): Record<string, string> => ({
  "Content-Type": "application/json",
  ...authorizationHeader(),
});

const getHeadersAuthFormData = (): Record<string, string> => ({
  "Content-Type": "multipart/form-data",
  ...authorizationHeader(),
});

export const HeadersUtil = {
  getHeaders: getHeaders,
  getHeadersAuth: getHeadersAuth,
  getHeadersAuthFormData: getHeadersAuthFormData,
}
